export default __webpack_public_path__ + "static/media/Elena.b7159754.jpg";